export const BC_CA = [
    '2024/11/11',
    '2024/12/25',
    '2024/12/26',
    '2025/1/1',
    '2025/2/17',
    '2025/3/14',
    '2025/4/18',
    '2025/5/19',
    '2025/5/23',
    '2025/6/19',
    '2025/6/20',
    '2025/7/1',
    '2025/8/4',
    '2025/8/29',
    '2025/9/1',
    '2025/9/30',
    '2025/10/13',
    '2025/11/11',
    '2025/12/25',
    '2025/12/26',
    '2026/1/1',
    '2026/2/16',
    '2026/3/27',
    '2026/4/3',
    '2026/5/18',
    '2026/5/22',
    '2026/6/18',
    '2026/6/19',
    '2026/7/1',
    '2026/8/3',
    '2026/9/4',
    '2026/9/7',
    '2026/9/30',
    '2026/10/12',
    '2026/11/11',
    '2026/12/25',
    '2026/12/28',
  ];